export default {
  language: 'Español',
  businessSectors: {
    title: 'Selecciona hasta 3 Sectores de Negocio',
    selected: 'Seleccionados',
    maxSelectionAlert: 'Puedes seleccionar hasta 3 sectores de negocio',
  },
  characteristics: {
    title: 'Selecciona hasta 3 Características',
    selected: 'Seleccionadas',
    maxSelectionAlert: 'Puedes seleccionar hasta 3 características',
  },
  errors: {
    loadOptions: 'Error al cargar opciones. Por favor, inténtalo de nuevo más tarde.',
    minSelection: 'Por favor, selecciona al menos una opción de cada categoría.',
    generateFailed: 'Error al generar startup. Por favor, inténtalo de nuevo.',
  },
  loading: {
    generating: 'Generando tu startup...',
  },
  buttons: {
    generate: 'Generar Startup',
    testGA: 'Probar Google Analytics',
    checkEvents: 'Verificar Eventos',
  },
  debug: {
    mode: 'Modo Debug',
  },
  validation: {
    maxBusinessSectors: 'Máximo 3 selecciones de sectores de negocio permitidas',
    maxCharacteristics: 'Máximo 3 selecciones de características permitidas',
    invalidBusinessSectors: 'Selecciones de sectores de negocio inválidas',
    invalidCharacteristics: 'Selecciones de características inválidas',
  }
}; 